import { SelectProps } from "@mui/material";
import { isArray } from "lodash";
import { ShipmentLocationType } from "../../../../graphql/generated";
import { ConditionValueSelectorComponentProps } from "../ConditionForm";
import EnumSelect from "../../../common/EnumSelect";
import { useTranslation } from "react-i18next";

const LocationTypeSelect = ({
  value,
  onChange,
  ...otherProps
}: ConditionValueSelectorComponentProps & Pick<SelectProps<string>, "sx">) => {
  const { t } = useTranslation("billingRules");
  return (
    <EnumSelect data-testid="location-type-select-shipment-location-type"
      label={otherProps.label}
      size="small"
      multiple
      enumObject={ShipmentLocationType}
      value={isArray(value) ? (value as ShipmentLocationType[]) : []}
      onChange={(event, value) => {
        onChange(value);
      }}
      withNoneOption
      noneOptionLabel={t("allStops", "All stops")}
      {...otherProps}
    />
  );
};

export default LocationTypeSelect;
